
import { SiriusBaseComponent } from 'sirius-framework';
import { ElementRef, Renderer2, ViewChildren, QueryList, Component } from '@angular/core';
import { FormGroup, AbstractControl, Validators, FormControl, ValidatorFn } from '@angular/forms';
import { InnerMenuOldProcessService } from '../../inner-menu-oldprocess.service';
import { CommonService } from '../../../shared/service/shared.service';
import { ProcessItem, OldProcessRequest } from '../../../shared/models/process.model';

declare const $: any;

@Component({
  selector: 'oldprocess',
  templateUrl: './oldprocess.component.html',
  styleUrls: ['./oldprocess.component.css']
})

export class OldProcessComponent extends SiriusBaseComponent<any> {
  @ViewChildren('elementTitles') elementTitles: QueryList<ElementRef>;
  pageIndex: number;
  titleText: string = "";
  searchForm: FormGroup;
  searchResultData: ProcessItem[] = [];
  noResult: boolean = false;
  selectedProcess: ProcessItem;
  /* String Resource */
  oldProcess_Title1: string;
  oldProcess_Title2: string;
  oldProcess_Title3: string;
  oldProcess_StartDate: string;
  oldProcess_StartWarning1: string;
  oldProcess_StartWarning2: string;
  oldProcess_EndDate: string;
  oldProcess_EndWarning1: string;
  oldProcess_EndWarning2: string;
  oldProcess_CarNo: string;
  oldProcess_Search: string;
  oldProcess_FirmReference: string;
  oldProcess_ProductNo: string;
  oldProcess_ProcessType: string;
  oldProcess_TotalAmount: string;
  oldProcess_ProcessStatus: string;
  oldProcess_Detail: string;
  oldProcess_NoRecords: string;
  oldProcess_BackButton: string;
  oldProcess_ActionDetail: string;
  oldProcess_ProcessTypeValue1: string;
  oldProcess_ProcessTypeValue2: string;
  oldProcess_StatusText1: string;
  oldProcess_StatusText2: string;
  oldProcess_StatusText3: string;
  oldProcess_StatusText4: string;
  oldProcess_StatusText5: string;
  oldProcess_StatusText6: string;
  oldProcess_StatusText7: string;
  oldProcess_StatusText9: string;
  constructor(private innerMenuOldProcessService: InnerMenuOldProcessService, private commonService: CommonService, private renderer: Renderer2) {
    super();
  }
  OnInit() {
    this.setStringResource();
    this.pageIndex = 0;
    this.titleText = this.oldProcess_Title1;
    this.commonService.selectedProcessDetail = null;
    this.commonService.selectedProcessAction = null;
    this.searchForm = new FormGroup({
      'startDate': new FormControl(null, [Validators.required, this.dateControl]),
      'endDate': new FormControl(null, [Validators.required, this.dateControl]),
      'carNo': new FormControl(null)
    });
    this.setDatePickers();
  }
  setStringResource() {
    this.oldProcess_Title1 = this.resourceService.getResource("oldProcess_Title1");
    this.oldProcess_Title2 = this.resourceService.getResource("oldProcess_Title2");
    this.oldProcess_Title3 = this.resourceService.getResource("oldProcess_Title3");
    this.oldProcess_StartDate = this.resourceService.getResource("oldProcess_StartDate");
    this.oldProcess_StartWarning1 = this.resourceService.getResource("oldProcess_StartWarning1")
    this.oldProcess_StartWarning2 = this.resourceService.getResource("oldProcess_StartWarning2")
    this.oldProcess_EndDate = this.resourceService.getResource("oldProcess_EndDate")
    this.oldProcess_EndWarning1 = this.resourceService.getResource("oldProcess_EndWarning1")
    this.oldProcess_EndWarning2 = this.resourceService.getResource("oldProcess_EndWarning2")
    this.oldProcess_CarNo = this.resourceService.getResource("oldProcess_CarNo")
    this.oldProcess_Search = this.resourceService.getResource("oldProcess_Search")
    this.oldProcess_FirmReference = this.resourceService.getResource("oldProcess_FirmReference")
    this.oldProcess_ProductNo = this.resourceService.getResource("oldProcess_ProductNo")
    this.oldProcess_ProcessType = this.resourceService.getResource("oldProcess_ProcessType")
    this.oldProcess_TotalAmount = this.resourceService.getResource("oldProcess_TotalAmount")
    this.oldProcess_ProcessStatus = this.resourceService.getResource("oldProcess_ProcessStatus")
    this.oldProcess_Detail = this.resourceService.getResource("oldProcess_Detail")
    this.oldProcess_NoRecords = this.resourceService.getResource("oldProcess_NoRecords")
    this.oldProcess_BackButton = this.resourceService.getResource("oldProcess_BackButton")
    this.oldProcess_ActionDetail = this.resourceService.getResource("oldProcess_ActionDetail")
    this.oldProcess_ProcessTypeValue1 = this.resourceService.getResource("oldProcess_ProcessTypeValue1");
    this.oldProcess_ProcessTypeValue2 = this.resourceService.getResource("oldProcess_ProcessTypeValue2");
    this.oldProcess_StatusText1 = this.resourceService.getResource("oldProcess_StatusText1");
    this.oldProcess_StatusText2 = this.resourceService.getResource("oldProcess_StatusText2");
    this.oldProcess_StatusText3 = this.resourceService.getResource("oldProcess_StatusText3");
    this.oldProcess_StatusText4 = this.resourceService.getResource("oldProcess_StatusText4");
    this.oldProcess_StatusText5 = this.resourceService.getResource("oldProcess_StatusText5");
    this.oldProcess_StatusText6 = this.resourceService.getResource("oldProcess_StatusText6");
    this.oldProcess_StatusText7 = this.resourceService.getResource("oldProcess_StatusText7");
    this.oldProcess_StatusText9 = this.resourceService.getResource("oldProcess_StatusText9");
  }
  getStartWarningText() {
    if (this.searchForm.controls.startDate.invalid && this.searchForm.controls.startDate.touched) {
      if (this.searchForm.controls.startDate.errors['required']) {
        return this.oldProcess_StartWarning1;
      }
      else {
        return this.oldProcess_StartWarning2;
      }
    }
  }
  getEndWarningText() {
    if (this.searchForm.controls.endDate.invalid && this.searchForm.controls.endDate.touched) {
      if (this.searchForm.controls.endDate.errors['required']) {
        return this.oldProcess_EndWarning1;
      }
      else {
        return this.oldProcess_EndWarning2;
      }
    }
  }
  getTypeText(type) {
    return type == "S" ? this.oldProcess_ProcessTypeValue1 : this.oldProcess_ProcessTypeValue2;
  }
  getStatusText(status) {
    let text = "";
    switch (status) {
      case "1":
        text = this.oldProcess_StatusText1;
        break;
      case "2":
        text = this.oldProcess_StatusText2;
        break;
      case "3":
        text = this.oldProcess_StatusText3;
        break;
      case "4":
        text = this.oldProcess_StatusText4;
        break;
      case "5":
        text = this.oldProcess_StatusText5;
        break;
      case "6":
        text = this.oldProcess_StatusText6;
        break;
      case "7":
        text = this.oldProcess_StatusText7;
        break;
      case "9":
        text = this.oldProcess_StatusText9;
        break;
    }
    return text;
  }
  onSearchSubmit() {
    this.noResult = false;
    if (this.searchForm.controls.startDate.valid && this.searchForm.controls.endDate.valid) {
      var oldProcessRequest: OldProcessRequest = {
        StartDate: this.searchForm.controls.startDate.value.replace(/\//g, ""),
        EndDate: this.searchForm.controls.endDate.value.replace(/\//g, ""),
        CarNo: this.searchForm.controls.carNo.value
      }
      var promise = this.innerMenuOldProcessService.getUserOldProcess(this.dataService, oldProcessRequest).toPromise();
      promise.then((result) => {
        if (result != null && Array.isArray(result) && result.length > 0) {
          this.searchResultData = result as Array<ProcessItem>;
        }
        else {
          this.noResult = true;
          this.searchResultData = null;
        }
      });
    }
    else {
      this.searchForm.controls.startDate.markAsTouched();
      this.searchForm.controls.endDate.markAsTouched();
    }
  }
  goProcessDetail(index: number) {
    this.selectedProcess = this.searchResultData[index];
    this.pageIndex = this.pageIndex + 1;
  }
  elementTitleClicked(i: number) {
    var elementList = this.elementTitles.toArray();
    for (let j = 0; j < elementList.length; j++) {
      if (j == i) {
        if (elementList[j].nativeElement.children[0].classList.contains("open"))
        {
          this.renderer.removeClass(elementList[j].nativeElement.children[0], 'open');
          this.renderer.removeClass(elementList[j].nativeElement.children[1], 'show');
        }
        else {
          this.renderer.addClass(elementList[j].nativeElement.children[0], 'open');
          this.renderer.addClass(elementList[j].nativeElement.children[1], 'show');
        }
      }
      else {
        this.renderer.removeClass(elementList[j].nativeElement.children[0], 'open');
        this.renderer.removeClass(elementList[j].nativeElement.children[1], 'show');
      }
    }
    $(document).ready(() => {
      $(".list-group").animate({ scrollTop: $('#elementTitleOfSearchResult' + i).height() * i }, 600);
    });
  }
  backButtonClicked() {
    this.pageIndex = this.pageIndex - 1;
    if (this.pageIndex == 0) {
      this.titleText = this.oldProcess_Title1;
      this.setDatePickers();
    }
    else {
      this.titleText = this.oldProcess_Title2;
    }
  }
  nextButtonClicked() {
    this.pageIndex = this.pageIndex + 1;
    if (this.pageIndex == 1) {
      this.titleText = this.oldProcess_Title2;
    }
    else {
      this.titleText = this.oldProcess_Title3;
    }
  }
  setDatePickers() {
    $(() => {
      $('#startDatePicker').datepicker({
        clearBtn: true,
        autoclose: true,
        format: "dd/mm/yyyy",
        orientation: "bottom left",
      });
      $('#startDatePicker').on('show', () => {
        if (this.searchForm.controls.startDate.value == null) {
          this.searchForm.controls.startDate.setValue(' ');
        }
      });
      $('#startDatePicker').on('changeDate', () => {
        this.searchForm.controls.startDate.setValue($('#startDatePicker').datepicker('getFormattedDate'));
      });
      $('#startDatePicker').on('hide', () => {
        if (this.searchForm.controls.startDate.value == ' ') {
          this.searchForm.controls.startDate.reset();
        }
        this.searchForm.controls.startDate.markAsTouched();
      });
      $('#endDatePicker').datepicker({
        clearBtn: true,
        autoclose: true,
        format: "dd/mm/yyyy",
        orientation: "bottom left",
      });
      $('#endDatePicker').on('show', () => {
        if (this.searchForm.controls.endDate.value == null)
          this.searchForm.controls.endDate.setValue(' ');
      });
      $('#endDatePicker').on('changeDate', () => {
        this.searchForm.controls.endDate.setValue($('#endDatePicker').datepicker('getFormattedDate'));
      });
      $('#endDatePicker').on('hide', () => {
        if (this.searchForm.controls.endDate.value == ' ') {
          this.searchForm.controls.endDate.reset();
        }
        this.searchForm.controls.endDate.markAsTouched();
      });
    });
  }
  dateControl(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.parent == null) {
      return null;
    }
    let startDateForm = control.parent.get("startDate");
    let endDateForm = control.parent.get("endDate");
    if (startDateForm == null || endDateForm == null) {
      return null;
    }
    if (startDateForm.value != null && startDateForm.value != " " && startDateForm.value != "" && endDateForm.value != null && endDateForm.value != " " && endDateForm.value != "") {
      let dayStart = +startDateForm.value.substr(0, 2);
      let monthStart = +startDateForm.value.substr(3, 2) - 1;
      let yearStart = +startDateForm.value.substr(6, 4);
      let startDate = new Date(yearStart, monthStart, dayStart);
      let dayEnd = +endDateForm.value.substr(0, 2);
      let monthEnd = +endDateForm.value.substr(3, 2) - 1;
      let yearEnd = +endDateForm.value.substr(6, 4);
      let endDate = new Date(yearEnd, monthEnd, dayEnd);
      if (startDate > endDate) {
        return { 'startDateBigger': true };
      }
      else {
        startDateForm.setErrors(null);
        endDateForm.setErrors(null);
      }
    }
    return null;
  }
}
